import React from 'react';
import PropTypes from 'prop-types';
import { iconLogout } from '~utils/svgIcons';
import './style.scss';

function MobileHeader({ logout }) {
    return (
        <div className="mobile-header">
            <h1>Личный кабинет</h1>
            <button type="button" onClick={() => window.confirm('Разлогиниться?') && logout()}>
                <span>Выйти</span>
                {iconLogout}
            </button>
        </div>
    );
}

MobileHeader.propTypes = {
    logout: PropTypes.func.isRequired,
};

export default MobileHeader;
export { MobileHeader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/mobile-header/index.js